<template>
  <Dialog v-model="dialog" showTitleDivider width="700">
    <template slot="title">
      <span class="_dialog-title">Nova seção</span>
    </template>

    <template slot="content">
      <v-list nav dense>
        <v-list-item-group v-model="sectionSelected" color="primary">
          <v-row no-gutters>
            <v-col
              v-for="(item, i) in sectionsFiltered"
              :key="i"
              cols="6"
              class="pr-12"
            >
              <v-list-item :value="item" class="listItem py-2" color="#192B46">
                <v-list-item-icon>
                  <v-icon color="#192B46" size="20">{{ item.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>
                    <b>{{ item.name }}</b>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
        </v-list-item-group>
      </v-list>
    </template>

    <template slot="actions">
      <div class="d-flex justify-end" style="gap: 8px">
        <Button
          outlined
          label="Cancelar"
          text-color="bt_color"
          textSize="0.80rem"
          @click="close"
        />

        <Button 
          :disabled="!sectionSelected"
          label="Confirmar" 
          textSize="0.80rem" 
          @click="addSection"
        />
      </div>
    </template>    
  </Dialog>
</template>

<script>
import { mapGetters } from "vuex";
import Dialog from '../../_v2/ui/Dialog.vue'
import Button from '../../_v2/ui/Button.vue'
import * as Schemas from '../../../schemas/sections'
import { parseObject } from '../../../schemas'

export default {
  components: {Dialog, Button},
  data() {
    return {
      sectionSelected: null,
      sections: [
        { name: "Menu", icon: "fa-regular fa-bars", type: 'menu', schema: Schemas.MENU_SCHEMA },
        { name: "Capa", icon: "fa-regular fa-star", type: 'cover', schema: Schemas.COVER_SCHEMA },
        { name: "Conteúdo", icon: "fa-solid fa-pen-field", type: 'content', schema: Schemas.CONTENT_SCHEMA },
        { name: "Programação", icon: "fa-regular fa-calendar-days", type: 'schedule', schema: Schemas.SCHEDULE_SCHEMA },
        { name: "Palestrantes", icon: "fa-regular fa-user", type: 'speakers', schema: Schemas.SPEAKERS_SCHEMA },
        { name: "Números", icon: "fa-regular fa-chart-simple", type: 'numbers', schema: Schemas.NUMBERS_SCHEMA },
        { name: "Depoimentos", icon: "fa-regular fa-message-text", type: 'testimonials', schema: Schemas.TESTIMONIALS_SCHEMA },
        { name: "Contato", icon: "fa-regular fa-envelope", type: 'contact', schema: Schemas.CONTACT_SCHEMA },
        { name: "Galeria de Imagens", icon: "fa-regular fa-images", type: 'gallery', schema: Schemas.GALLERY_SCHEMA },
        { name: "Logomarcas", icon: "fa-regular fa-copyright", type: 'logos', schema: Schemas.LOGOS_SCHEMA },
        { name: "Perguntas Frenquentes", icon: "fa-regular fa-circle-question", type: 'personalizedFaq', schema: Schemas.PERSONALIZED_FAQ_SCHEMA },
        { name: "Ingressos", icon: "fa-regular fa-ticket", type: 'tickets', schema: Schemas.TICKETS_SCHEMA },
        { name: "Cadastro em Campanha", icon: "fa-brands fa-wpforms", type: 'campaign', schema: Schemas.CAMPAIGN_SCHEMA },
        { name: "Materiais", icon: "fa-regular fa-newspaper", type: 'materials', schema: Schemas.MATERIALS_SCHEMA },
        { name: "Patrocinadores", icon: "fa-regular fa-users", type: 'sponsors', schema: Schemas.SPONSORS_SCHEMA },
        { name: "Rodapé", icon: "fa-regular fa-block-quote", type: 'footer', schema: Schemas.FOOTER_SCHEMA }
      ],
    };
  },

  computed: {
    ...mapGetters(["infos", "dialogSection", "speakers", "navbar", "logos", 'selectedPage']),

    sectionsFiltered() {
      const onlyOne = ['menu', 'footer', 'cover']
      const mainPage = this.infos.pages.find(page => page.route === '/')

      return this.sections.filter(section => {
        if (onlyOne.includes(section.type)) {
          const check = this.infos.sections.find(item => section.type === item.type)
          if (check || this.selectedPage !== mainPage.id) return false
          else return true
        }
        return section
      })
    },

    dialog: {
      get () { return this.dialogSection.open},
      set (v) { 
        this.$store.dispatch("setDialogSection", Object.assign(this.dialogSection, {open: v}));
      }
    }
  },

  methods: {    
    close() {
      this.$store.dispatch("setDialogSection", { open: false, selectedSection: null });
    },

    guid() {
      return (this.s4() + this.s4() + "-" + this.s4() + "-" + this.s4() + "-" + this.s4() + "-" + this.s4() + this.s4() + this.s4())
    },

    s4() {
      return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    },    

    async addSection() {
      const id = this.sectionSelected.type + `-${this.guid()}`;
      const defaultLayout = this.infos.layout.length > 1 ? this.infos.layout[1].id : ''

      const newSection = this.sectionSelected.schema({id, idLayout: defaultLayout})
      newSection.pageId = this.selectedPage
      
      this.addInitialItems(newSection)

      const footer = this.checkHasFooter()

      if (footer.footerIndex !== -1 && footer.isFooterLastElement) this.infos.sections.splice(footer.footerIndex, 0, newSection)
      else this.infos.sections.push(newSection)
    
      this.$store.dispatch("setDialogSection", { open: false, selectedSection: null })
      this.$store.dispatch("setNav", { open: true, sectionId: "" })

      setTimeout(() => { this.$vuetify.goTo(`#${newSection.id}`) }, 100)
      console.log('@.@ CRIOU -->', newSection)
    },

    addInitialItems (newSection) {
      if (newSection.type === 'tickets') {
        newSection.itemsV2 = []
        newSection.itemsV2Desc = []
      }

      if (newSection.type === 'speakers') newSection.items = JSON.parse(JSON.stringify(this.speakers))

      if (newSection.type === 'contact') {
        const contactItems = [
          { field: "nome", type: "text", caption: "Nome" },
          { field: "email", type: "email", caption: "E-mail" },
          { field: "phone", type: "phone", caption: "Telefone" },
          { field: "message", type: "long-text", caption: "Mensagem" },
          { field: "", type: "submit", caption: "Enviar" }
        ]

        contactItems.forEach(obj => { 
          newSection.items.push(parseObject({schema: Schemas.CONTACT_ITEM_OPTION(), target: obj})) 
        })
      }

      if (newSection.type === 'campaign') {
        const campaignItems = [
          { field: "nome", type: "text", caption: "Nome" },
          { field: "email", type: "email", caption: "E-mail" },
          { field: "phone", type: "phone", caption: "Telefone" },
          { field: "", type: "submit", caption: "Enviar" }
        ]

        campaignItems.forEach(obj => { 
          newSection.items.push(parseObject({schema: Schemas.CAMPAIGN_ITEM_OPTION(), target: obj})) 
        })        
      }
    },

    checkHasFooter () {
      const footerIndex = this.infos.sections.findIndex(section => section.type === 'footer');
      const isFooterLastElement = footerIndex === this.infos.sections.length - 1;

      return { footerIndex, isFooterLastElement }
    }    
  }
};
</script>

<style scoped>
.v-list-item--active {
  background-color: #e3eef9;
}

.buttonDialogAdd {
  text-transform: none;
  background-color: #0067af !important;
  height: 40px !important;
  width: 128px !important;
  border-radius: 56px !important;
  padding: 11px, 32px, 11px, 32px !important;
}

b {
  font-size: 16px;
  font-weight: 450;
  line-height: 20px;
  color: #192b46;
}

.buttonDialogClose {
  text-transform: none;
  color: #0067af !important;
  background-color: transparent !important;
  height: 40px !important;
  width: 128px !important;
  border-radius: 56px !important;
  padding: 11px, 32px, 11px, 32px !important;
}
</style>
